<template>
	<div>
          <!-- <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link>
        <router-link :to="{name: 'eps-admin-master-menu' }" class="root">
            Super Master
        </router-link>
        <span class="child">/ Subject Authority Appointment Import</span>
    </v-row><br /> -->
		<v-card class="card">
			<v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
				<span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
				<v-btn dark text @click="snackbar = false">Close</v-btn>
			</v-snackbar>
			<v-card class="box">
				<div class="flex">
					<div>
						<v-toolbar-title>Import Subject Authority Appointment</v-toolbar-title>
					</div>
					<div>
						<a
							href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/import_subject_auth.csv"
						>
							<v-btn
								:loading="loading3"
								:disabled="loading3"
								color="success"
								class="ma-2 white--text downbtn"
								@click="loader = 'loading3'"
							>
								<v-icon left dark>mdi-cloud-download</v-icon>
								Download import CSV format
							</v-btn>
						</a>
					</div>
				</div>

				<!-- <div>
					<v-col lg="6">
						<v-row
							><span class="warn">*NOTE:File should be in CVS format</span></v-row
						>

						<v-row>
							<v-file-input
								class="file"
								placeholder="Upload Subject Authoity Appointment Data File"
								prepend-icon="mdi-file"
								show-size
								outlined
								dense
								v-model="file"
							></v-file-input>
							<v-btn
								class="button"
								style="margin-left: 10px;"
								@click="submitFile"
								:loading="output_load"
								>Submit</v-btn
							>
						</v-row>
					</v-col>
				</div> -->
        <v-card-text>
            <v-row>
                <v-col cols="12" lg="4" sm="12">
					<!-- <v-file-input
								class="file"
								placeholder="Upload Subject Authoity Appointment Data File"
								prepend-icon="mdi-file"
								show-size
								outlined
								accept=".csv"
								v-model="file"
							></v-file-input> -->
                    <v-file-input dense v-model="file" accept=".csv" :hint="file != null? '':'Please Select File'" persistent-hint color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined :show-size="1000"> </v-file-input>
                </v-col>
                <v-col cols="4">
                </v-col>
                <!-- <v-col cols="4">
                    <a href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/import_exam-time_table.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="success" class="ma-2 white--text downbtn " @click="loader = 'loading3'">
                            <v-icon left dark>mdi-cloud-download</v-icon>
                            Download import CSV format
                        </v-btn>
                    </a>
                </v-col> -->
            </v-row>
            <v-row>
                <v-col cols="4">
                    <center>
                        <v-btn @click="submitFile" :loading="output_load" class="button">
                            Upload
                            <v-icon right>mdi-cloud-upload</v-icon>
                        </v-btn>
                    </center>
                </v-col>
            </v-row>
        </v-card-text>



			</v-card>

			<template v-if="load == true">
				<v-data-table
					:headers="headers"
					:items="courseauthoritydata"
					:item-value="id"
					sort-by
					class="elevation-1 mytable"
					:search="search"
					:loading="output_load"
				>
					<template v-slot:top>
						<v-toolbar flat color="white">
							<v-toolbar-title>Appointment Authority </v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
							<v-spacer></v-spacer>
							<v-text-field
								v-model="search"
								append-icon="search"
								label="Search"
								single-line
								hide-details
							></v-text-field>
							<span style="width: 20px"></span>
							<!-- <v-btn color="indigo darken-4"  dark class="mb-2" @click="openDialog">
                <v-icon left>mdi-account-plus</v-icon>Add New Subject Authority Appintment
              </v-btn> -->
						</v-toolbar>
					</template>
					<template v-slot:item.isactive="{ item }">
						<span v-if="item.isactive == true">
							<v-icon class="mr-2" color="success" @click="toggle(item)"
								>mdi-check-circle-outline</v-icon
							>
						</span>
						<span v-else>
							<v-icon class="mr-2" color="error" @click="toggle(item)"
								>mdi-close-circle-outline</v-icon
							>
						</span>
					</template>
					<template v-slot:item.edit="{ item }">
						<v-icon color="green" class="mr-2" @click="editDialogFunction(item)"
							>mdi-pencil-box-outline</v-icon
						>
					</template>
				</v-data-table>
			</template>
			<template v-if="statuslist != null">
				<v-data-table
					:headers="headers1"
					:items="statuslist"
					sort-by
					class="elevation-1"
					:search="search"
					:loading="output_load"
				>
					<template v-slot:top>
						<v-toolbar flat color="white">
							<v-toolbar-title>CSV Error Row </v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
							<v-spacer></v-spacer>
							<v-text-field
								v-model="search"
								append-icon="search"
								label="Search"
								single-line
								hide-details
							></v-text-field>
							<span style="width: 20px"></span>
							<!-- <v-btn color="indigo darken-4"  dark class="mb-2" @click="openDialog">
                <v-icon left>mdi-account-plus</v-icon>Add New Subject Authority Appintment
              </v-btn> -->
						</v-toolbar>
					</template>
				</v-data-table>
			</template>

			<v-dialog v-model="editDialog" persistent max-width="600px">
				<v-card>
					<v-card-title class="heading">
						<span >Edit Subject Authority Appointment Details</span>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-row>
								<v-col cols="12">
									<v-text-field
										v-model="editedItem.course"
										label="Course Name"
										readonly
									></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-autocomplete
										:items="this.porgtype_list"
										item-value="id"
										item-text="name"
										readonly
										label="Program"
										v-model="editedItem.programtype"
									></v-autocomplete>
								</v-col>
								<v-col cols="12">
									<v-autocomplete
										:items="this.programList"
										item-value="id"
										item-text="name"
										readonly
										label=" Program Type" 
										v-model="editedItem.program"
									></v-autocomplete>
								</v-col>
								<v-col cols="12">
									<v-autocomplete
										:items="yearList"
										item-value="id"
										item-text="name"
										readonly
										v-model="editedItem.year"
										label="Year"
									></v-autocomplete>
								</v-col>
								<v-col cols="12">
									<v-autocomplete
										:items="authorityLevel"
										return-object
										item-text="name"
										v-model="editedItem.authority"
										label="Authority Type"
									></v-autocomplete>
								</v-col>

								<v-col cols="12">
									<v-autocomplete
										:items="instructor"
										item-value="id"
										item-text="instructor"
										v-model="editedItem.instructor"
										label="Instructor Type"
									></v-autocomplete>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn class="button-cancel" text @click="editDialog = false"
							>Close</v-btn
						>
						<v-btn class="button" text @click="saveEdited">Save</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card>
	</div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      file: null,
      id:'',
      course:'',
      program: "",
      programtype: "",
      statuslist:null,
      authority: "",
      porgtype_list:"",
      instructor: null,
      programList:null,
      yearList:null,
      authorityLevel:null,
      courseauthoritydata: "",
      load: false,
      loading3: false,
      search: "",
      dialog: false,
      editDialog: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      InstRecord: "",
      headers: [
        { text: "Sr.no", value: "srno" },
        { text: "Course Name", value: "course" },
        { text: "Program", value: "program.name" },
        { text: "Program Type", value: "programtype.name" },
        { text: "Year", value: "year.name" },
        { text: "Instructor", value: "instructor" },
        { text: "Authority Name", value: "authority.name" },
        { text: "Action", value: "edit" }
      ],
       headers1: [
        { text: "Row No", value: "row" },
        { text: "Course Code", value: "course" },
        { text: "Authority Name", value: "authority" },
        { text: "Employee Code", value: "instructor" },
        
      ],
      editedItem: {
        id:'',
        course: "",
        program: null,
        programtype: null,
        year:null,
        instructor: null,
        authority: null
      },
      output_load: false
    };
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    submitFile() {
      if (this.file == null) {
        this.showSnackbar("#b71c1c", "Please select the CSV file!"); // show snackbar
        //alert("Please select the file!");
      } else {
        this.output_load = true;
        let formData = new FormData();
        //console.log(this.file.size)
        formData.append("file", this.file);
        //console.log(formData)
        axios
          .post("SubjectAppointment/importAuthorityData", formData, { 
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(res => {
            if (res.data.msg == "200") {
             this.courseauthoritydata = res.data.course_auth_data;
              this.load = true;
              if( res.data.statuslist.length-1>1)
              {
                this.showSnackbar("#b71c1c", "CSV file contains error some rows are added successfully... ");
                // this.statuslist = res.data.statuslist
              }
              else
               this.showSnackbar("#4caf50", "Subject Authority Appintment added successfully...");
              //this.getsubjectoffering()
              // Object.assign(this.courselist[this.editedIndex], this.editedItem);
            this.file = null
              
            }
          })
          .catch(function() {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            this.output_load = false;
          });
        //     }
      }
    }, //end of the fuction

    /*
        Handles a change on the file upload
      */
    addInst() {
      if (this.empcode == null) {
        alert("* marked field is required");
      } else {
        this.dialog = false;
        const data = {
          empcode: this.empcode,
          fullname: this.fullname,
          email: this.email,
          contactno: this.contactno,
          program: this.program,
          department: this.department,
          instType: this.InstType
        };
        //console.log(data);
        axios
          .post("/Import/addNewInstructor", data)
          .then(res => {
            if (res.data.msg == "200") {
              //console.log("res data:::: " + res.data.statuslist);
              this.statuslist = res.data.statuslist;
              this.load = true;
              this.showSnackbar("#4caf50", "Instructor added successfully..."); // show snackbar on success
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
            }
          })
          .catch(error => {
            window.console.log(error);
          });
      }
    },
    openDialog() {
      this.dialog = true;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editDialogFunction(item) {
      
      this.editedItem = Object.assign({}, item);
      this.editDialog = true;
    },
    onLoad() {
      axios
        .post("/SubjectAppointment/importdata")
        .then(res => {
          if (res.data.msg == "200") {
            //alert(res.data.statuslist)
            this.courseauthoritydata = res.data.course_auth_data;
            this.porgtype_list = res.data.porgtype_list;
            this.programList = res.data.programlist;
            this.yearList = res.data.year_list;
            this.instructor = res.data.ins_list;
            this.authorityLevel = res.data.auth_levels;
            this.load = true;
          } else {
           
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    saveEdited() {
      axios
        .post("/SubjectAppointment/editSubjectAuthority", this.editedItem) 
        .then(res => {
          if (res.data.msg == "200") {
            this.courseauthoritydata.push(this.editedItem);
            this.editDialog = false;
            this.showSnackbar("#4caf50", "Subject Authority details updated!!!"); // show snackbar on success
            this.courseauthoritydata = res.data.course_auth_data;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          window.console.log(error);
        });
    },
    toggle(val) {
      const data = {
        userId: val.id,
        status: val.isactive
      };
      axios
        .post("/Import/toggleActiveStatus", data)
        .then(res => {
          if (res.data.msg == "200") {
            this.showSnackbar("#4caf50", "status changed successfully..."); // show snackbar on success
            this.statuslist.push(data.isactive);
            this.statuslist = res.data.statuslist;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        });
    }
  }
};
</script>
<style scoped>
.downbtn {
	float: right;
}
.mytable /deep/ thead th {
	background-color: hsla(190, 99%, 30%, 1) !important;
	color: white !important;
	white-space: nowrap !important;
}
.heading-page {
	color: hsla(190, 99%, 30%, 1);
	font-weight: 500;
	background: #add8e630;
	border: 1px solid hsla(190, 99%, 30%, 1);
}
.box {
	background-color: #add8e630;
	margin: 8px !important;
	padding: 8px;
}
.card {
	border: 2px solid hsla(190, 99%, 30%, 1) !important;
}
.flex {
	display: flex;
	justify-content: space-between;
}
.warn {
	color: red;
	font-style: italic;
	font-size: 15px;
	padding: 5px;
}
.file >>> .v-input__slot {
	background: white !important;
	border-color: hsla(190, 99%, 30%, 1) !important;
}
.button {
	background-color: white !important;
}
.button:hover {
	color: white !important;
	background-color: hsla(190, 99%, 30%, 1) !important;
}

@media only screen and (max-width: 600px) {
	.flex {
		display: block;
	}
}
</style>